<template>
  <v-dialog v-model="add_job_modal" max-width="1300" persistent>
    <v-card :loading="loading">
      <v-card-title>Add Job</v-card-title>
      <v-card-text>
        <v-form>
          <v-row dense>
            <v-col cols="2">
              <v-autocomplete
                v-model="form_data.group_id"
                label="Group"
                dense
                :items="job_group_list"
                hide-details
                item-text="ig_tiitle"
                item-value="ig_id"
                placeholder=" "
              ></v-autocomplete>
            </v-col>
            <v-col cols="2">
              <v-text-field
                label="Job Name"
                dense
                autofocus
                v-model="form_data.job_name"
                :error-messages="form_error.job_name"
                :hide-details="!form_error.job_name"
                placeholder=" "
                class="capitalize-first-letter"
              ></v-text-field>
            </v-col>
            <v-col cols="1" style="min-width:10%">
              <v-autocomplete
                v-model="form_data.uom_id"
                dense
                :items="uom_list"
                :error-messages="form_error.uom_id"
                :hide-details="!form_error.uom_id"
                label="UOM"
                placeholder=" "
              ></v-autocomplete>
            </v-col>
            <v-col cols="1">
              <v-text-field
                dense
                v-model="form_data.labor_cost"
                :error-messages="form_error.labor_cost"
                :hide-details="!form_error.labor_cost"
                label="Labor Cost"
                placeholder=" "
                @input="calculateAmount()"
              ></v-text-field>
            </v-col>
            <v-col cols="1" style="min-width: 9%;" class="green-background-input">
              <v-text-field
                v-model="form_data.material_cost"
                dense
                hide-details
                label="Material Cost"
                readonly
                placeholder=" "
              ></v-text-field>
            </v-col>
            <v-col cols="1" style="min-width: 10%;" class="green-background-input ml-1">
              <v-text-field
                v-model="form_data.total_cost"
                dense
                readonly
                hide-details
                label="Total Cost"
                placeholder=" "
              ></v-text-field>
            </v-col>
            <v-col cols="1" style="min-width: 8%;" class="green-background-input ml-1">
              <v-text-field
                v-model="form_data.sales_price"
                dense
                hide-details
                label="Sales Price"
                readonly
                placeholder=" "
              ></v-text-field>
            </v-col>
            <v-col cols="2" style="max-width: 12%;">
              <v-switch
                class="pt-0 ma-0"
                v-model="form_data.px_override"
                label="Px. Override"
                color="success"
                dense
                hide-details
              ></v-switch>
            </v-col>
            <v-col cols="1" v-if="form_data.px_override">
              <v-text-field
                v-model="form_data.override_price"
                dense
                hide-details
                label="Price"
                placeholder=" "
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense class="mt-1">
            <v-col cols="4">
              <v-autocomplete
                dense
                label="Preferred Vendor"
                v-model="form_data.vendor_ids"
                :items="sort_list"
                :error-messages="form_error.vendor_ids"
                :hide-details="!form_error.vendor_ids"
                item-text="v_name"
                item-value="vendor_id"
                placeholder=" "
                multiple
              >
                <template v-slot:selection="{ index }">
                  <span class="grey--text caption" v-if="index == 0">{{selected_multi_values}}</span>
                </template>
                <template v-slot:no-data>
                  <div class="d-flex align-center">
                    <span
                      class="pl-2"
                      style="
                        font-size: 0.8125rem;
                        font-weight: 500;
                        line-height: 1rem;
                      "
                    >No Vendor Found!</span>
                    <span
                      @click="addVendor"
                      class="mdi mdi-plus-circle pl-1 pr-2"
                      style="
                        font-size: 1.5rem;
                        cursor: pointer;
                        color: #6e9a35 !important;
                      "
                    ></span>
                  </div>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="1">
              <v-switch
                class="pt-0 ma-0"
                v-model="form_data.active"
                label="Active"
                color="success"
                dense
                hide-details
              ></v-switch>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <v-row dense class="primary">
                <v-col cols="3" class="d-flex align-center">
                  <span class="white--text">Item</span>
                </v-col>
                <v-col class="d-flex align-center">
                  <span class="white--text">Vendor</span>
                </v-col>
                <v-col cols="1" class="d-flex align-center">
                  <span class="white--text">Qty</span>
                </v-col>
                <v-col cols="2" class="d-flex align-center" style="max-width: 10%;">
                  <span class="white--text">UOM</span>
                </v-col>
                <v-col cols="2" class="d-flex align-center justify-end" style="max-width: 9%;">
                  <span class="white--text">Rate</span>
                </v-col>
                <v-col cols="1" class="d-flex align-center justify-end">
                  <span class="white--text">Amount</span>
                </v-col>
                <v-col cols="1" class="d-flex align-center justify-center" style="max-width: 4%;">
                  <v-icon @click="addRemoveJob('yes')" color="white">mdi-plus-circle</v-icon>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row dense v-for="(job, index) in job_materials" :key="index">
            <v-col cols="3">
              <v-autocomplete
                dense
                v-model="job.item_id"
                :items="item_list"
                item-text="item_name"
                item-value="item_id"
                hide-details
                @change="getItemDetails(index)"
              >
                <template v-slot:no-data>
                  <div class="d-flex align-center">
                    <span
                      class="pl-2"
                      style="
                        font-size: 0.8125rem;
                        font-weight: 500;
                        line-height: 1rem;
                      "
                    >No Item Found!</span>
                    <span
                      @click="addItem"
                      class="mdi mdi-plus-circle pl-1 pr-2"
                      style="
                        font-size: 1.5rem;
                        cursor: pointer;
                        color: #6e9a35 !important;
                      "
                    ></span>
                  </div>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col>
              <v-autocomplete
                dense
                hide-details
                v-model="job.vendor_id"
                :items="job.item_vendor_list"
                item-text="vendor.v_name"
                item-value="vendor_id"
                @change="changeVendor(index)"
              ></v-autocomplete>
            </v-col>
            <v-col cols="1">
              <v-text-field dense v-model="job.qty" hide-details @input="calculateAmount()"></v-text-field>
            </v-col>
            <v-col cols="2" style="max-width: 10%;">
              <v-autocomplete
                v-model="job.uom_id"
                dense
                :items="uom_list"
                hide-details
                readonly
                class="green-background-input"
              ></v-autocomplete>
            </v-col>
            <v-col cols="2" style="max-width: 9%;">
              <v-text-field
                dense
                v-model="job.rate"
                hide-details
                class="green-background-input"
                reverse
              >
                <template v-slot:append>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon size="22" v-bind="attrs" v-on="on">mdi-eye-outline</v-icon>
                    </template>
                    <span>
                      Invoice Price: {{job.invoice_price}} |
                      Deliver Price: {{job.deliver_price}} |
                      Sales Price: {{job.sales_price}}
                    </span>
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="1">
              <v-text-field
                dense
                hide-details
                readonly
                class="green-background-input"
                :value="(job.qty * job.rate > 0)?job.qty * job.rate:''"
                reverse
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="d-flex align-center justify-center" style="max-width: 4%;">
              <v-icon @click="addRemoveJob('no',index)">mdi-close-circle</v-icon>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn color="error" @click="closePopup()" :disabled="loading">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="saveJob()" :loading="loading">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import axios from "../../plugins/axios";
export default {
  name: "AddJob",
  data: () => ({
    loading: false,
    form_data: {
      active: true,
      px_override: true,
      vendor_ids: []
    },
    setting_data: {},
    form_error: {},
    uom_list: [],
    job_group_list: [],
    vendor_list: [],
    item_list: [],
    job_materials: [
      {
        item_id: null,
        vendor_id: null,
        qty: null,
        uom_id: null,
        rate: null,
        amount: null,
        item_vendor_list: [],
        invoice_price: null,
        deliver_price: null,
        sales_price: null
      }
    ]
  }),
  watch: {
    add_job_modal: {
      handler(val) {
        if (val) {
          this.form_data = {
            active: true,
            px_override: true
          };

          this.job_materials = [
            {
              item_id: null,
              vendor_id: null,
              qty: null,
              uom_id: null,
              rate: null,
              amount: null,
              item_vendor_list: [],
              invoice_price: null,
              deliver_price: null,
              sales_price: null
            }
          ];
          this.getJobSettings();
        }
      }
    }
  },
  computed: {
    ...mapState("job", ["add_job_modal"]),
    sort_list() {
      let selected_vendors = this.form_data.vendor_ids;
      let vendors = this.vendor_list.filter(item => {
        if (selected_vendors) {
          if (!selected_vendors.includes(item.vendor_id)) {
            return item;
          }
        } else {
          return item;
        }
      });
      vendors = vendors.sort((a, b) => {
        let fa = a.v_name,
          fb = b.v_name;
        if (fa < fb) {
          return -1;
        }
        if (fa > fb) {
          return 1;
        }
        return 0;
      });
      this.vendor_list.filter(item => {
        if (selected_vendors) {
          if (selected_vendors.includes(item.vendor_id)) {
            vendors.unshift(item);
          }
        }
      });
      return vendors;
    },
    selected_multi_values() {
      let return_data = "";
      if (this.form_data.vendor_ids.length > 0) {
        this.vendor_list.filter(item => {
          if (item.vendor_id == this.form_data.vendor_ids[0]) {
            return_data = item.v_name;
          }
        });
        if (this.form_data.vendor_ids.length > 1) {
          let totalVen = this.form_data.vendor_ids.length - 1;
          return_data = return_data + " (" + totalVen + " More)";
        }
      }
      return return_data;
    }
  },
  methods: {
    ...mapMutations("job", ["setJobData"]),
    addVendor() {
      this.$router.push({ path: "/vendors" });
    },
    addItem() {
      this.$router.push({ path: "/items" });
    },
    calculateAmount() {
      let material_cost = 0;
      this.job_materials.map(job => {
        if (job.qty && job.rate) {
          material_cost += job.qty * job.rate;
        }
      });
      this.form_data.material_cost = material_cost;

      let total_cost = material_cost;
      if (this.form_data.labor_cost > 0) {
        total_cost =
          parseFloat(total_cost) + parseFloat(this.form_data.labor_cost);
      }
      this.form_data.total_cost = total_cost;

      if (this.setting_data.markup > 0) {
        this.form_data.sales_price =
          total_cost + (total_cost * this.setting_data.markup) / 100;
      } else {
        this.form_data.sales_price = total_cost;
      }
    },
    getItemDetails(index) {
      let _self = this;
      axios
        .get("get_item?id=" + this.job_materials[index].item_id)
        .then(response => {
          if (response.data.status) {
            _self.job_materials[index].item_vendor_list =
              response.data.data.vendors;
            _self.job_materials[index].uom_id = response.data.data.item_uom;
            if (response.data.data.vendors.length == 1) {
              _self.job_materials[index].vendor_id =
                _self.job_materials[index].item_vendor_list[0].vendor_id;
              _self.changeVendor(index);
            }
          }
        })
        .catch(function() {});
    },
    changeVendor(index) {
      let selected_vendor = this.job_materials[index].item_vendor_list.filter(
        item => {
          return item.vendor_id == this.job_materials[index].vendor_id;
        }
      )[0];
      if (selected_vendor.price_override == "1") {
        this.job_materials[index].rate = selected_vendor.override_price;
        this.job_materials[index].sales_price = selected_vendor.override_price;
      } else {
        this.job_materials[index].rate = selected_vendor.sales_price;
        this.job_materials[index].sales_price = selected_vendor.sales_price;
      }
      this.job_materials[index].invoice_price = selected_vendor.invoice_price;
      this.job_materials[index].deliver_price = selected_vendor.deliver_price;
    },
    addRemoveJob(is_add, index) {
      if (is_add == "no") {
        this.job_materials.splice(index, 1);
        this.calculateAmount();
      } else {
        this.job_materials.push({
          item_id: null,
          vendor_id: null,
          qty: null,
          uom_id: null,
          rate: null,
          amount: null,
          item_vendor_list: [],
          invoice_price: null,
          deliver_price: null,
          sales_price: null
        });
      }
    },
    saveJob() {
      this.loading = true;
      this.form_error = {};
      let _self = this;
      this.form_data.job_materials = this.job_materials;
      let serverData = JSON.parse(JSON.stringify(this._data.form_data));
      axios
        .post("add_job", serverData)
        .then(function(res) {
          let data = res.data;
          console.log("job data", data);
          if (!data.status) {
            for (let key in data.errors) {
              _self.form_error[key] = data.errors[key][0];
            }
          } else {
            _self.setJobData({ key: "add_job_modal", value: false });
            _self.setJobData({
              key: "last_add_job_id",
              value: data.data.job_id
            });
          }
          _self.loading = false;
        })
        .catch(function(error) {
          console.log("FAILURE!!", error);
          _self.loading = false;
        });
    },
    closePopup() {
      this.setJobData({ key: "add_job_modal", value: false });
    },
    getLogItemUom() {
      this.loading = true;
      let _self = this;
      axios
        .get("get_item_uom")
        .then(response => {
          if (response.data.status) {
            _self.uom_list = response.data.data;
            _self.loading = false;
          }
        })
        .catch(function() {
          _self.loading = false;
        });
    },
    getVendors() {
      this.loading = true;
      let _self = this;
      axios
        .get("vendor_list?itemsPerPage=-1&sortBy=v_name")
        .then(response => {
          console.log(response);
          _self.vendor_list = response.data.data.data;
          _self.loading = false;
        })
        .catch(function() {
          _self.loading = false;
        });
    },
    getItems() {
      this.loading = true;
      let _self = this;
      axios
        .get("items_list?itemsPerPage=-1&item_type='0'")
        .then(response => {
          _self.item_list = response.data.data.data;
          _self.loading = false;
        })
        .catch(function() {
          _self.loading = false;
        });
    },
    getJobSettings() {
      let _self = this;
      this.loading = "accent";
      axios
        .get("get_job_setting")
        .then(response => {
          let data = response.data.data;
          for (let key in data) {
            this.setting_data[key] = data[key] == null ? "" : data[key];
          }
          _self.loading = false;
        })
        .catch(function() {
          this.loading = false;
        });
    },
    getJobGroup() {
      let _self = this;
      axios
        .get("group_list?itemsPerPage=-1&module=JOB_MASTER")
        .then(response => {
          _self.job_group_list = response.data.data.data;
        })
        .catch(function() {});
    }
  },
  mounted: function() {
    this.getLogItemUom();
    this.getVendors();
    this.getItems();
    this.getJobGroup();
  }
};
</script>

<style>
</style>